import React from 'react';
import { FormLabel } from './FormLabel';

interface InputProps {
  label: string;
  value: string | number;
  onChange: (value: number | string) => void;
  type?: 'text' | 'number' | 'date';
  error?: string;
  min?: number;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  tooltip?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  type = 'text',
  error,
  min,
  placeholder,
  disabled = false,
  required = false,
  tooltip
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (type === 'number') {
      // Allow empty string when the user clears the input
      onChange(newValue === "" ? "" : Number(newValue));
    } else {
      onChange(newValue);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <FormLabel label={label} required={required} tooltip={tooltip} />
      )}
      <input
        type={type}
        value={value === null || value === undefined ? "" : value}
        onChange={handleChange}
        min={type === 'number' && min !== undefined ? min : undefined}
        step={type === 'number' ? 'any' : undefined}
        placeholder={placeholder}
        disabled={disabled}
        className={`rounded-md border ${
          error ? 'border-red-300' : 'border-gray-300'
        } px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          disabled ? 'bg-gray-100' : ''
        }`}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};
